import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const Toast = ({
  show,
  type = 'success',
  message,
  onDismiss,
  duration = 3000,
  action = null,
}) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!show) return undefined;

    const timer = setTimeout(() => {
      onDismissRef.current();
    }, duration);

    return () => clearTimeout(timer);
  }, [show, duration]);

  if (!show || !message) {
    return null;
  }

  const isSuccess = type === 'success';

  return (
    <div
      className="fixed bottom-24 left-1/2 z-[60] w-full max-w-md -translate-x-1/2 px-4"
      role="status"
      aria-live="polite"
    >
      <div
        className={`flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg ${
          isSuccess ? 'bg-green-600 text-white' : 'bg-red-600 text-white'
        }`}
      >
        <span className="flex-1 text-sm font-medium">{message}</span>
        {action}
        <button
          type="button"
          onClick={onDismiss}
          className="flex-shrink-0 rounded p-1 text-white/90 transition-colors hover:bg-white/20 hover:text-white"
          aria-label="Dismiss notification"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
